module.exports = __webpack_public_path__ + "img/gf.ddb187ba.png";